import { useTranslation } from 'react-i18next'
import { useQueryClient } from '@tanstack/react-query'

import { DescriptionIcon, Text } from '@mercai/clever'
import { DocumentCard } from '../../../document-card'
import { FINANCE_PROFILE_URL, QUERIES_ADMIN } from '@/services'

import { ProfileDocumentsProps } from './profile-documents.type'
import styles from './profile-documents.module.css'

export const ProfileDocuments = ({ profile }: ProfileDocumentsProps) => {
  const { t } = useTranslation('screenProfileShow')
  const queryClient = useQueryClient()

  const onSuccessUpload = () => {
    queryClient.invalidateQueries({
      queryKey: [QUERIES_ADMIN.PROFILE.module, profile?.uuid],
    })
  }

  return (
    <div className={styles.core}>
      <div className={styles.header}>
        <DescriptionIcon />

        <Text variant="title-base">{t('generalViewDocumentsLabel')}</Text>
      </div>

      <div className={styles.content}>
        <DocumentCard
          title={t('generalViewDocumentSatLabel')}
          fileField="tax_compliance_certificate_file"
          file={profile?.taxComplianceCertificate}
          method="PATCH"
          onSuccessUpload={onSuccessUpload}
          addUrl={FINANCE_PROFILE_URL(profile?.uuid || '')}
        />

        <DocumentCard
          title={t('generalViewDocumentResidenceLabel')}
          fileField="address_proof_file"
          file={profile?.addressProof}
          method="PATCH"
          onSuccessUpload={onSuccessUpload}
          addUrl={FINANCE_PROFILE_URL(profile?.uuid || '')}
        />

        <DocumentCard
          title={t('generalViewDocumentConstitutiveActLabel')}
          fileField="constitutive_act_file"
          file={profile?.constitutiveAct}
          method="PATCH"
          onSuccessUpload={onSuccessUpload}
          addUrl={FINANCE_PROFILE_URL(profile?.uuid || '')}
        />

        <DocumentCard
          title={t('generalViewDocumentTaxSituationLabel')}
          fileField="tax_situation_file"
          file={profile?.taxSituation}
          method="PATCH"
          onSuccessUpload={onSuccessUpload}
          addUrl={FINANCE_PROFILE_URL(profile?.uuid || '')}
        />

        <DocumentCard
          title={t('generalViewDocumentBlacktrustLabel')}
          fileField="risk_assessment_report_file"
          file={profile?.financeProfile?.riskAssessmentReportFile}
          method="PATCH"
          onSuccessUpload={onSuccessUpload}
          addUrl={FINANCE_PROFILE_URL(profile?.uuid || '')}
        />

        <DocumentCard
          title={t('generalViewDocumentVisitLabel')}
          fileField="site_inspection_report_file"
          file={profile?.financeProfile?.siteInspectionReportFile}
          method="PATCH"
          onSuccessUpload={onSuccessUpload}
          addUrl={FINANCE_PROFILE_URL(profile?.uuid || '')}
        />

        <DocumentCard
          title={t('generalViewDocumentPagareLabel')}
          fileField="promissory_note_file"
          file={profile?.financeProfile?.promissoryNoteFile}
          method="PATCH"
          onSuccessUpload={onSuccessUpload}
          addUrl={FINANCE_PROFILE_URL(profile?.uuid || '')}
        />
      </div>
    </div>
  )
}
